import React from "react";
import DOMPurify from "dompurify";
import "./MerchandiseInfo.css";
import close from "../../../../assets/rr310/red-x.png";

const MercInfo = ({ inforModal, setInforModal, merchInfoDesc }) => {
  const sanitizedDescription = DOMPurify.sanitize(merchInfoDesc?.Description);
  // console.log(merchInfoDesc);
  return (
    <>
      <div className="inf0_modal_container">
        <div
          className="close_button_container"
          onClick={() => setInforModal(!inforModal)}
        >
          <img src={close} className="close_button_info" alt="close-icon" />
        </div>
        <div className="info_content">
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />
        </div>
      </div>
    </>
  );
};

export default MercInfo;
